<jhi-bary-card titleKey="cgv.title">
  <div body>
    <div *ngIf="'tarot' === transporter.technicalName">
      <p>Article 1 – OBJET ET DOMAINE D’APPLICATION</p>
      <p>
        Les présentes conditions générales de vente («les CGV») régissent les relations entre un donneur d’ordre et
        <a name="_Hlk61349364">Transports LTAROT </a>pour toute opération en lien avec le transport de marchandises par route de toute provenance et pour toute destination sur le
        territoire français.
      </p>
      <p>
        Le contrat-type propre aux prestations convenues s’applique en cas de silence des CGV et les termes utilisés dans les CGV s’entendent conformément aux définitions du
        contrat-type applicable.
      </p>
      <p>En cas de conflit avec les conditions générales du donneur d’ordre ou les termes du contrat-type applicable, les CGV prévalent.</p>
      <p>ARTICLE 2 – ACTIVITÉS DE Transports LTAROT</p>
      <p>Transports LTAROT est susceptible d’agir en qualité de transporteur, commissionnaire de transport, transitaire ou mandataire.</p>
      <p>En aucun cas Transports LTAROT n’assumera des responsabilités pour des opérations relatives à la réglementation douanière.</p>
      <p>
        Sauf si le contexte requiert qu’il en soit autrement, toute référence à Transports LTAROT inclut toutes les entités ayant un lien capitalistique avec Transports LTAROT, ses
        substitués et sous-traitants.
      </p>
      <p>ARTICLE 3 – PRIX DES PRESTATIONS</p>
      <p>3.1.</p>
      <p>
        Le prix des prestations est calculé pour chaque opération en fonction 1) des caractéristiques des prestations à réaliser,
        <br />
        2) des informations fournies par le donneur d’ordre, notamment la nature, le poids, le volume et les dimensions de la marchandise à transporter,
        <br />
        3) de l’itinéraire requis,
        <br />
        4) des conditions et tarifs des substitués,
        <br />
        5) des dispositions légales, règlementaires et/ou internationales applicables et
        <br />
        6) du prix du carburant.
        <br />
        <br />
      </p>
      <p>En cas de modification d’un ou plusieurs de ces éléments après la remise d’une cotation, Transports LTAROT peut modifier le prix en conséquence.</p>
      <p>3.2.</p>
      <p>Le prix s’entend hors taxe, redevance ou impôt qui seraient dus à quelque titre que ce soit.</p>
      <p>ARTICLE 4 – ASSURANCE DES MARCHANDISES</p>
      <p>
        À la demande expresse et écrite du donneur d’ordre et sous réserve de l’acceptation écrite de Transports LTAROT, les marchandises peuvent être assurées par une compagnie
        d’assurance notoirement solvable à la date de la souscription de la garantie.
      </p>
      <p>
        La demande de souscription de garantie ne vaut que pour le transport visé et doit préciser les risques à couvrir et les valeurs à garantir. À défaut de précision, seuls les
        risques ordinaires seront garantis. Sont exclus en toute hypothèse les risques de guerre, actes de terrorisme et grèves.
      </p>
      <p>
        Le donneur d’ordre reconnaît que Transports LTAROT agit comme mandataire de la compagnie d’assurance; le donneur d’ordre est réputé avoir pris connaissance et accepté les
        conditions de la police d’assurance et est tenu de payer la prime correspondante.
      </p>
      <p>Sur simple demande du donneur d’ordre, un certificat d’assurance sera émis.</p>
      <p>ARTICLE 5 – EXÉCUTION DES PRESTATIONS</p>
      <p>5.1.</p>
      <p>Les dates de départ et d’arrivée de la marchandise sont données à titre indicatif.</p>
      <p>5.2.</p>
      <p>
        Le donneur d’ordre est tenu de fournir en temps utile, lors de la commande de fret ou 24 heures avant la prise en charge de la marchandise, toutes les informations et tous
        documents permettant l’exécution de toutes les prestations (de transport ou annexes) et d’assurer la sécurité des personnes et des biens.
      </p>
      <p>
        Les informations requises sont celles listées au contrat-type applicable et sont notamment relatives à l’accessibilité du lieu de prise en charge ou de livraison, le
        matériel requis, les spécificités des installations de chargement ou déchargement.
      </p>
      <p>
        En cas d’information lacunaire, de retard ou d’absence de personnel chez l’expéditeur ou le destinataire et/ou de tout acte ou omission du donneur d’ordre ayant pour
        conséquence de mettre obstacle à la prise en charge ou à la livraison de la marchandise lors de sa présentation, des frais de nouvelle présentation seront facturés au
        donneur d’ordre à hauteur de 50% des frais de transport hors taxe.
      </p>
      <p>
        Tout temps d’attente supérieur à 30 minutes d’un ensemble routier pour l’une des raisons mentionnées au paragraphe précédent donne lieu à facturation de frais additionnels
        correspondant au coût de revient de l’immobilisation de l’ensemble routier et du personnel de Transports LTAROT, sans pouvoir être inférieur à 55 € hors taxe par heure.
      </p>
      <p>5.3.</p>
      <p>Les documents et informations fournis par le donneur d’ordre engagent sa seule responsabilité.</p>
      <p>5.4.</p>
      <p>Toute instruction spécifique doit être adressée par écrit, ne vaut que pour l’opération visée et doit être acceptée par écrit de Transports LTAROT.</p>
      <p>5.5.</p>
      <p>
        Transports LTAROT est adhérent notamment du groupement ÉVOLUTRANS et du réseau VOLUPAL et VOLULOTS, solution d’optimisation du transport de lots palettisés. En conséquence,
        toute marchandise palettisée confiée à Transports LTAROT est susceptible d’être partiellement ou totalement acheminée par un ou plusieurs autres membres des réseaux
        auxquels Transports LTAROT est adhérent et toute commande auprès de Transports LTAROT vaut acceptation sans réserve du donneur d’ordre d’une telle sous-traitance.
      </p>
      <p>5.6.</p>
      <p>
        Pour diverses raisons tenant notamment au volume ou à la quantité de marchandise, à des demandes spécifiques du donneur d’ordre ou aux conditions d’accessibilité du lieu de
        prise en charge ou de livraison, l’acheminement de la marchandise peut requérir le concours d’un autre transporteur ou l’utilisation d’un matériel additionnel (par exemple
        : tractionnaire) et/ou spécial (par exemple : véhicules électriques, tricycles, véhicules équipés de grues,...) autre que celui dont dispose Transports LTAROT. Toute
        commande auprès de Transports LTAROT vaut acceptation sans réserve du donneur d’ordre du recours à des sous-traitants pour la réalisation des prestations requérant le
        concours d’un autre transporteur ou l’utilisation d’un matériel additionnel et/ou spécial.
      </p>
      <p>ARTICLE 6 – OBLIGATIONS DU DONNEUR D’ORDRE</p>
      <p>
        <strong>6.1. Commande en ligne</strong>
        – Le donneur d’ordre qui utilise un service en ligne pour commander une prestation de Transports LTAROT s'oblige notamment à :
      </p>
      <p>
        1. Communiquer des données exactes et complètes lors de l'inscription sur le site concerné et à les maintenir à jour, complètes et exactes en tout temps. À défaut,
        Transports LTAROT est en droit de refuser d’exécuter les prestations commandées.
      </p>
      <p>2. Respecter l’ensemble des obligations mises à sa charge par les conditions générales d’utilisation du site<strong>.</strong></p>
      <p>
        <strong></strong>
      </p>
      <p>
        <strong>6.2. Conditionnement</strong>
      </p>
      <p>
        – L’expéditeur prend toutes les mesures de conditionnement, d’emballage et de marquage de la marchandise requises pour la protection de ladite marchandise, l’exécution du
        transport et des opérations de manutention dans les conditions propres à assurer la sécurité des personnes et des biens et la préservation de l’environnement.
      </p>
      <p>
        L’expéditeur appose de manière lisible sur la marchandise les étiquettes comportant toutes les informations permettant l’identification immédiate et sans équivoque de
        l’expéditeur, du destinataire, du lieu de livraison, de la nature de la marchandise et, le cas échéant, toute information requise par les dispositions applicables,
        notamment celles relatives aux produits dangereux. Ces informations doivent correspondre aux mentions portées au document de transport.
      </p>
      <p>
        Le donneur d’ordre répond, le cas échéant avec l’expéditeur (s’il est différent), de tout dommage résultant du conditionnement, de l’emballage, du marquage ou de
        l’étiquetage défectueux ou inadéquat de la marchandise.
      </p>
      <p>6.3. Obligations déclaratives</p>
      <p>
        – Le donneur d’ordre informe Transports LTAROT TRANSPORTEUR de la nature exacte et de toute spécificité de la marchandise exigeant des mesures particulières notamment en
        raison de sa valeur, des risques de vol, de sa dangerosité ou de sa fragilité. Le donneur d’ordre ne remet aucune marchandise illicite ou prohibée à Transports LTAROT.
      </p>
      <p>
        Le donneur d’ordre est seul responsable et relève Transports LTAROT indemne de toutes les conséquences directes et indirectes résultant de déclarations ou documents
        erronés, incomplets, non-conformes ou transmis tardivement, y compris celles relatives à la documentation douanière.
      </p>
      <p>
        <strong> 6.4. Responsabilité des opérations de chargement et déchargement </strong>
        - La responsabilité des dommages matériels survenus au cours des opérations de chargement, arrimage, calage, sanglage et déchargement de la marchandise incombe à celui qui
        les exécute, soit par principe :
      </p>
      <p>- à Transports LTAROT pour les envois de moins de trois (3) tonnes.</p>
      <p>
        - à l’expéditeur au chargement et au destinataire au déchargement pour les envois de trois (3) tonnes et plus; Transports LTAROT ou son préposé participant aux opérations
        est réputé agir pour le compte de l’expéditeur ou du destinataire.
      </p>
      <p>
        <strong>6.5. Responsabilité du choix de matériels spéciaux</strong>
        – À la demande du donneur d’ordre qui en précise les spécifications, Transports LTAROT peut mettre à disposition un matériel particulier pour le transport de certaines
        marchandises notamment sous température dirigée, hors gabarit ou dangereuses. Le donneur d’ordre est seul responsable du choix du matériel demandé.
      </p>
      <p>6.6. Réserves</p>
      <p>
        – En cas de perte, d’avarie ou de tout dommage subi par la marchandise, ou en cas de retard, il appartient au destinataire ou au réceptionnaire de procéder aux
        constatations adéquates, de prendre des réserves motivées et circonstanciées et de manière général d’effectuer tous actes utiles à la conservation des recours et confirmer
        lesdites réserves dans les formes et les délais légaux. À défaut, aucun recours ne pourra être exercé contre Transports LTAROT.
      </p>
      <p>6.7. Refus ou défaillance du destinataire</p>
      <p>
        – En cas de refus de la marchandise ou de défaillance du destinataire, quelle qu’en soit la raison, le donneur d’ordre demeure redevable du prix des prestations et de tous
        les frais engagés pour le compte de la marchandise.
      </p>
      <p>6.8. Livraison contre remboursement</p>
      <p>
        – La stipulation d’une livraison contre remboursement ne vaut pas déclaration de valeur de la marchandise et par conséquent, n’emporte pas de modification des règles
        d’indemnisation.
      </p>
      <p>ARTICLE 7 – RESPONSABILITÉ DE Transports LTAROT</p>
      <p>
        En cas de préjudice dument prouvé et imputable à Transports LTAROT, Transports LTAROT ne peut être tenu que des dommages directs et prévisibles lors de la commande, dans la
        limite des montants prévus ci-après.
      </p>
      <p>
        En aucun cas, Transports LTAROT ne peut être tenu au paiement de pénalités de retard encourues par le donneur d’ordre en application d’un contrat auquel Transports LTAROT
        est tiers.
      </p>
      <p>
        <strong>7.1. Responsabilité du fait des substitués</strong>
        – La responsabilité de Transports LTAROT GLS est limitée à celle encourue par ses substitués. À défaut de limitations spécifiques aux substitués, la responsabilité de
        Transports LTAROT est limitée conformément aux stipulations du 7.2 à 7.4. ci-après.
      </p>
      <p>
        <strong>7.2. Responsabilité personnelle de </strong>
        Transports LTAROT <strong>pour perte et avarie</strong>– En cas de perte ou avarie à la marchandise dument prouvée et dont Transports LTAROT est légalement responsable,
        l’indemnité éventuellement due par Transports LTAROT pour tous les préjudices en découlant est limitée :
      </p>
      <p>
        1) pour tout envoi inférieur à trois tonnes : à 33 € par kilogramme de poids brut de marchandise perdue ou avariée sans pouvoir excéder 1000€ par colis perdu, incomplet ou
        endommagé ; ou
      </p>
      <p>
        2) pour tout envoi égal ou supérieur à trois tonnes : à 20€ par kilogramme de poids brut de marchandise perdue ou avariée pour chacun des objets compris dans l’envoi sans
        pouvoir excéder la somme correspondant au poids brut de l’envoi exprimé en tonnes multiplié par 3200.
      </p>
      <p>7.3. Responsabilité en cas de retard</p>
      <p>
        – Sauf cas de force majeure, manquement de l’expéditeur ou du destinataire ou autre cause externe à Transports LTAROT, en cas de préjudice prouvé résultant du retard de
        livraison par rapport à la date et à l’heure indiquées par Transports LTAROT, l’indemnité sera limitée dans les conditions suivantes :
      </p>
      <ul type="disc">
        <li>pour tout retard supérieur à 24 heures: 25% du prix du transport hors taxe</li>
        <li>pour tout retard supérieur à 48 heures: 50% du prix du transport hors taxe</li>
        <li>pour tout retard supérieur à 72 heures: 75% du prix du transport hors taxe</li>
        <li>pour tout retard supérieur à 96 heures: 100% du prix du transport hors taxe</li>
      </ul>
      <p>
        La durée prise en compte pour le calcul du retard est celle écoulée entre la date et l’heure indiquée par Transports LTAROT et la date et l’heure d’arrivée de l’ensemble
        routier sur le lieu de livraison, peu importe que la livraison soit devenue impossible dans l’intervalle et nécessite une présentation ultérieure.
      </p>
      <p>7.4. Responsabilité pour les autres dommages</p>
      <p>
        – Pour tous les dommages autres que les avaries ou perte, si la responsabilité de Transports LTAROT est engagée, l’indemnité éventuellement due par Transports LTAROT ne
        peut excéder le plus faible des deux montants suivants :
      </p>
      <p>1) le prix du transport de la marchandise hors taxe ou, si le préjudice trouve son origine dans une prestation annexe, le prix de ladite prestation;</p>
      <p>2) le montant de la limitation calculée conformément aux stipulations du 7.2. ci-dessus.</p>
      <p>7.5. Cotations</p>
      <p>
        – Tous les tarifs, toutes les cotations ou offres de prix publiés ou émises par Transports LTAROT sont fixés en fonction des limites de responsabilité stipulées aux
        articles 7.1.à 7.4. ci-dessus.
      </p>
      <p>7.6. Déclaration de valeur ou assurance</p>
      <p>
        – Sous réserve d’en faire la demande par écrit avant la confirmation de commande et sous réserve de l’acceptation par écrit de Transports LTAROT, le donneur d’ordre peut
        souscrire une déclaration de valeur. Le montant de la déclaration de valeur fixé par ses soins se substitue au montant des limites d’indemnisation stipulées aux articles
        7.1. à 7.4. ci-dessus. La déclaration de valeur ne vaut que pour le transport expressément visé et peut justifier un supplément de prix.
      </p>
      <p>
        Le donneur d’ordre peut, avant la confirmation de commande, demander à Transports LTAROT de souscrire pour son compte une assurance couvrant la marchandise transportée en
        précisant les risques à couvrir et/ou les valeurs à garantir. La souscription doit être demandée par écrit, ne vaut que pour le transport expressément visé et vaut
        engagement irrévocable du donneur d’ordre de payer la prime correspondante (dont Transports LTAROT ne fera pas l’avance).
      </p>
      <p>7.7. Intérêt spécial à la livraison</p>
      <p>
        – Sous réserve d’en faire la demande par écrit avant la confirmation de commande et sous réserve de l’acceptation par écrit de Transports LTAROT, le donneur d’ordre peut
        faire une déclaration d’intérêt spécial à la livraison afin de substituer, en cas de retard de livraison dument prouvé, le montant de cette déclaration aux limites de
        responsabilité stipulées aux articles 7.1. à 7.4. ci-dessus. La déclaration d’intérêt spécial ne vaut que pour le transport expressément visé et peut justifier un
        supplément de prix.
      </p>
      <p>ARTICLE 8 – ANNULATION ET REFUS DE LA MARCHANDISE</p>
      <p>8.1.</p>
      <p>
        L’annulation annoncée par le donneur d’ordre moins de 24 heures avant le jour convenu ou l'heure convenue de la mise à disposition du véhicule au chargement ouvre droit, à
        une indemnité au moins égale à 50 % du prix hors taxe des prestations.
      </p>
      <p>8.2.</p>
      <p>
        En cas de refus du réceptionnaire de prendre livraison de tout ou partie de la marchandise pour quelque cause que ce soit, Transports LTAROT en informe le donneur d’ordre.
        Le donneur d’ordre s’oblige à transmettre ses instructions à Transports LTAROT et à payer le prix de toute prestation additionnelle, y compris l’entreposage et/ou le
        transport de la marchandise éventuellement renvoyée à l’expéditeur.
      </p>
      <p>ARTICLE 9 – CONDITIONS DE PAIEMENT</p>
      <p>8.1.</p>
      <p>
        Le paiement du prix des prestations est exigible à réception de la facture, à son lieu d’émission et, en toute hypothèse, dans un délai ne pouvant excéder trente (30) jours
        à compter de la date de son émission.
      </p>
      <p>8.2.</p>
      <p>La compensation unilatérale du montant des dommages allégués avec le prix de transport ou des prestations annexes est interdite.</p>
      <p>8.3.</p>
      <p>
        Tout retard de paiement entraîne de plein droit, le jour suivant la date de règlement figurant sur la facture, l’exigibilité d’intérêts de retard d’un montant équivalent à
        cinq (5) fois le taux d’intérêt légal, ainsi qu’une indemnité forfaitaire pour les frais de recouvrement ne pouvant être inférieure à 40 €, sans préjudice du droit à
        réparation intégrale de l’ensemble des dommages résultant du retard de paiement.
      </p>
      <p>
        Le retard de paiement d’une facture entraîne de plein droit déchéance du terme de toute autre créance de Transports LTAROT, à quelque titre que ce soit, y compris en cas
        d’acceptation d’effets, et autorise Transports LTAROT à exiger le paiement comptant avant exécution de toute nouvelle prestation.
      </p>
      <p>8.4.</p>
      <p>Tout paiement partiel sera imputé en premier lieu sur la partie non privilégiée de la créance.</p>
      <p>ARTICLE 10 – DROIT DE RÉTENTION ET DROIT DE GAGE CONVENTIONNELS</p>
      <p>
        Le donneur d’ordre reconnaît expressément à Transports LTAROT un droit de rétention conventionnel et un droit de gage conventionnel, tous deux portant sur toutes les
        marchandises, valeurs et documents en possession de Transports LTAROT, et ce, en garantie de toute créance que Transports LTAROT détiendrait contre lui, y compris les
        créances antérieures ou sans lien de connexité avec les marchandises, valeurs ou documents effectivement en sa possession.
      </p>
      <p>ARTICLE 11 – PRESCRIPTION</p>
      <p>
        Toute action relative à l’exécution des prestations, quelles qu’elles soient, est prescrite dans un délai d’un (1) an à compter de la date à laquelle la prestation
        litigieuse a été exécutée ou, en cas d’inexécution, de la date à laquelle elle aurait dû être exécutée.5
      </p>
      <p>ARTICLE 12 – FIN DE LA RELATION COMMERCIALE</p>
      <p>11.1.</p>
      <p>
        En cas de relation commerciale établie, le donneur d’ordre et Transports LTAROT peuvent y mettre fin par l’envoi d’une lettre recommandée avec avis de réception sous
        réserve du respect des délais de préavis ne pouvant être inférieurs à ceux prévus au contrat-type dit « général ».
      </p>
      <p>11.2.</p>
      <p>
        En cas de manquements graves ou répétés dument prouvés aux obligations de l’une des parties, l’autre partie peut mettre fin à la relation sans préavis ni indemnité un (1)
        mois après l’envoi d’une lettre de mise en demeure demeurée sans effet.
      </p>
      <p>ARTICLE 13 – INVALIDITÉ PARTIELLE</p>
      <p>Si une des stipulations des CGV est déclarée nulle ou réputée non écrite, la validité des autres stipulations n’en sera pas affectée.</p>
      <p>ARTICLE 14 – LOI APPLICABLE ET JURIDICTION COMPÉTENTE</p>
      <p>
        Tout différend relatif à la validité, l’interprétation ou l’exécution des CGV sera soumis à la loi française et devra être porté devant le Tribunal de commerce de Laval, y
        compris en cas de pluralité de défendeurs ou d’appel en garantie.
      </p>
    </div>

    <!-- NOTE : Les cgv sont hébergés sur le bucket de prod. -->
    <div *ngIf="oldTransporterFormat.indexOf(transporter.technicalName!) === -1">
      <ngx-spinner [name]="loadingSpinner" bdColor="rgba(0,0,0,0.5)" size="medium" color="#fff" type="ball-grid-pulse" [fullScreen]="false"></ngx-spinner>
      <ngx-doc-viewer
        #docViewerComponent
        *ngIf="doc"
        [url]="doc"
        (loaded)="this.spinnerService.hide(loadingSpinner)"
        viewer="google"
        style="width: 100%; height: 70vh"
      ></ngx-doc-viewer>
    </div>
  </div>
</jhi-bary-card>
